import { MobxStore } from "./mobxStore";

export const stores = {
    mobxStore: new MobxStore()
}




// WEBPACK FOOTER //
// ./src/stores/index.js